<template>
  <div class="vheader">
    <div class="vheader-nav">
      <div class="vheader-left">
        <!-- <router-link to="/"></router-link> -->
        <a href="/"><img src="../assets/index/logo.png" /></a>
        <!-- <img v-lazy="" > -->
      </div>
      <div class="vheader-right">
        <ul>
          <li class="active">
              <router-link to="/">首页</router-link>
          </li>
          <li>
              <router-link to="/intro">公司简介</router-link>
          </li>
          <li>
              <router-link to="/business">业务介绍</router-link>
          </li>
          <li>
              <router-link to="/joinus">加入我们</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vheader',
  data(){
    return{}
  },
  props: {
  }
}
</script>

<style scoped lang="less">
  .router-link-exact-active {border-bottom: 3px solid #c87b75;color: #b2261e !important;}
  .FontSize{font-weight: normal;font-stretch: normal;color: #000000;letter-spacing: 0px;}
  .vheader{
    width: 100%;
    height: 80px;
    background-color: rgba(255,255,255,0.85);
    box-shadow: 0px 1px 0px 0px rgba(178, 38, 30, 0.52);
    position: fixed;;
    left: 0;
    top: 0;
    z-index: 100;
    .vheader-nav{
      width: 1100px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .vheader-left{
        // float: left;
        img{
          width: 130px;
          // height: 41px;
          // padding-top: 27.5px;
        }
      }
      .vheader-right{
        // float: right;
        margin-right: -23px;
        ul{
          height: 80px;
        li{
          float: left;width: 127px;height: 100%; line-height: 80px;text-align: center;
          }
        // li:hover{background-color: #f6efe2;cursor: pointer;}
        li:visited{
          background-color: #f6efe2;cursor: pointer;
          }
        a{
          .FontSize;width: 100%;height: 77px;display: inline-block;font-size: 20px;font-weight: 600;
        }
        }
      }
    }
  }
</style>
